<template>
  <div class="page-content-wrapper user-list-page"  v-check-permission="'list-payment-rules'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Reglas para la matrícula</h4>
              <p class="text-muted m-b-30 font-14">Desde aquí podrás gestionar reglas de pago para la matricula.</p>

              <div class="table-rep-plugin">

                <div>
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <router-link v-check-permission="'edit-payment-rule'" to="/edit-payment-rule-for-tuition" class="btn btn-info waves-effect waves-light pull-right">Agregar nuevo</router-link>
                      <button class="btn btn-primary pull-right mr-3" @click="getAllPaymentRulesForTuition()">Actualizar / Mostrar todos</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive b-0" data-pattern="priority-columns">

                <table class="table table-striped">
                  <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Carrera</th>
                    <th>Estado</th>
                    <th>Creado el</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="rule in paymentRulesForTuition" :key="rule._id">
                    <td>{{ rule.name }}</td>
                    <td><b v-if="rule.career">{{ rule.career.name }}</b></td>
                    <td><span class="badge badge-success" v-if="rule.active">Activo</span><span class="badge badge-primary" v-if="!rule.active">Inactivo</span> </td>
                    <td>{{ rule.createdAt | moment("DD/MM/YYYY") }}</td>
                    <td class="pull-right">
                      <router-link :to="{ name: 'edit-payment-rule-for-tuition', params: { id: rule._id }}" class="text-info mr-3"><i class="fa fa-pencil"></i></router-link>
                      <a href="javascript:void(0);" class="text-primary"  @click="deletePaymentRule(rule._id)"><i class="fa fa-minus-circle"></i></a>
                    </td>
                  </tr>
                  <tr v-if="paymentRulesForTuition.length === 0">
                    <td colspan="5">Aun no se han creado reglas para la matrícula.</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> <!-- end col -->
    </div> <!-- end row -->

  </div><!-- container -->

  </div>
</template>


<script>
  export default {
    name: 'list-payment-rules-for-tuition',

    created () {
      this.getAllPaymentRulesForTuition()
    },


    data () {
      return {
        params: {},
      }
    },


    computed: {
      paymentRulesForTuition: function () {
        return this.$store.getters.getAllPaymentRulesForTuition
      }
    },


    methods: {

      getAllPaymentRulesForTuition () {
        this.$loader.loading();
        this.$store.dispatch('getAllPaymentRulesForTuition', { params : this.params })
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },

      deletePaymentRule (id) {
        var self = this;

        this.$message.delete().then(function (result) {

          if(result.value) {
            self.$store.dispatch('deletePaymentRuleForTuition', { id : id })
              .then((response) => {
                if(response.success) {
                  self.$message.success();
                } else {
                  self.$message.error({text: response.message});
                }
              })
              .catch((response) => {
                self.$message.error({text: response.message});
              })
          }

        })

      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/PaymentRulesForTuitionScreen.vue